import { render, staticRenderFns } from "./ListNotification.vue?vue&type=template&id=04ebaf01"
import script from "./ListNotification.vue?vue&type=script&lang=ts"
export * from "./ListNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports